/* ============================================================================
   Pet's Table — /pages/order: paso de WhatsApp opcional (brief del 11-ago-2026)
   ----------------------------------------------------------------------------
   Convierte el paso "Tus datos" en lo que pide el brief: sin correo, con el
   teléfono opcional y con una salida clara para quien no quiera dejarlo.

   Se aplica SOLO a las variantes de VARIANTES_CON_WHATSAPP. La variante A
   conserva el paso de siempre, que sí exige correo y teléfono.

   Sobre cómo está hecho: se modifica el paso que construye pt-plan-builder en
   vez de reescribirlo. Ese archivo crea el bloque y engancha sus listeners a
   #leadNext y #leadSkip en el mismo momento; si aquí se reemplazara el HTML,
   esos listeners se perderían y los botones dejarían de avanzar. Por eso los
   elementos existentes se conservan y solo se reordena, se oculta y se añade.

   Y vive aparte porque pt-plan-builder se reescribe cada tanto.
   ========================================================================== */
(function () {
  'use strict';

  var VARIANTES_CON_WHATSAPP = ['B'];

  /* Cuando cambie la redacción legal hay que subir esta versión: es lo que
     permite saber después qué texto leyó exactamente quien aceptó. */
  var VERSION_CONSENTIMIENTO = '2026-08-11';

  var TEXTO_PLAN =
    'Al enviarte el plan, aceptas que Pet’s Table te contacte por WhatsApp ' +
    'para compartir tu recomendación y dar seguimiento a tu solicitud. Puedes ' +
    'dejar de recibir mensajes cuando quieras. Consulta nuestro ';

  var TEXTO_MARKETING =
    'También quiero recibir promociones y novedades de Pet’s Table por WhatsApp.';

  function variante() {
    try { return window.PT_AB || localStorage.getItem('pt_variant') || 'A'; }
    catch (e) { return window.PT_AB || 'A'; }
  }

  if (VARIANTES_CON_WHATSAPP.indexOf(variante()) < 0) return;

  /* México: 10 dígitos. Se guarda en E.164 porque es lo que espera cualquier
     proveedor de WhatsApp, y aparte se conserva lo que escribió el usuario. */
  function normalizar(valor) {
    var d = String(valor || '').replace(/\D/g, '');
    if (d.length === 12 && d.indexOf('52') === 0) d = d.slice(2);
    if (d.length === 11 && d.indexOf('1') === 0) d = d.slice(1);
    return d.length === 10 ? '+52' + d : '';
  }

  function montar() {
    var sec = document.getElementById('leadSec');
    if (!sec || sec.dataset.ptWhatsapp) return false;

    var phone = document.getElementById('leadPhone');
    var btnNext = document.getElementById('leadNext');
    var btnSkip = document.getElementById('leadSkip');
    if (!phone || !btnNext || !btnSkip) return false;

    sec.dataset.ptWhatsapp = '1';

    /* ── El correo sale de este paso ──────────────────────────────────────
       Shopify lo pide en el checkout. Además, pasarlo por la URL es lo que
       provocaba que llegara como usuario%40dominio.com. */
    var email = document.getElementById('leadEmail');
    if (email) {
      var etiquetaEmail = email.previousElementSibling;
      if (etiquetaEmail && etiquetaEmail.classList.contains('fl')) etiquetaEmail.remove();
      email.remove();
    }

    /* ── Encabezado ──────────────────────────────────────────────────────── */
    var lbl = sec.querySelector('.lbl');
    if (lbl) {
      var n = lbl.querySelector('.n');
      lbl.innerHTML = '';
      if (n) lbl.appendChild(n);
      lbl.appendChild(document.createTextNode(' Tu WhatsApp '));
      var op = document.createElement('span');
      op.className = 'pt-wa-opcional';
      op.textContent = 'Opcional';
      lbl.appendChild(op);
    }

    var hint = document.getElementById('leadHint');
    if (hint) {
      /* El nombre del perro, cuando ya lo dio: hace la pregunta concreta en
         vez de genérica. */
      var nombre = '';
      try { nombre = ((window.state || {}).name || '').trim(); } catch (e) {}
      var titulo = document.createElement('div');
      titulo.className = 'pt-wa-titulo';
      titulo.textContent = nombre
        ? '¿Quieres recibir el plan de ' + nombre + ' por WhatsApp?'
        : '¿Quieres recibir el plan de tu perro por WhatsApp?';
      hint.parentNode.insertBefore(titulo, hint);
      hint.textContent =
        'Te enviaremos su recomendación para que puedas revisarla después y ayudarte si tienes dudas.';
      hint.className = 'pt-wa-sub';
    }

    var etiquetaTel = phone.previousElementSibling;
    if (etiquetaTel && etiquetaTel.classList.contains('fl')) etiquetaTel.textContent = 'Número de WhatsApp';
    phone.setAttribute('placeholder', '10 dígitos');

    /* ── Consentimientos ──────────────────────────────────────────────────
       El de "mándame el plan" es un texto, no una casilla: se acepta al pulsar
       el botón, porque es lo que la persona está pidiendo. El promocional sí
       es casilla aparte y desmarcada, que es justo lo que el brief separa. */
    var viejo = sec.querySelector('.leadconsent');
    var marketing = document.createElement('label');
    marketing.className = 'leadconsent pt-wa-marketing';
    marketing.innerHTML =
      '<input type="checkbox" id="waMarketing" disabled><span>' + TEXTO_MARKETING + '</span>';

    var aviso = document.createElement('div');
    aviso.className = 'pt-wa-legal';
    aviso.innerHTML =
      TEXTO_PLAN +
      '<a href="https://petstable.mx/policies/privacy-policy" target="_blank" rel="noopener">Aviso de Privacidad</a>.';

    if (viejo) {
      viejo.parentNode.insertBefore(aviso, viejo);
      viejo.parentNode.insertBefore(marketing, viejo);
      viejo.remove();   /* la casilla que mezclaba plan y promociones */
    } else {
      phone.parentNode.insertBefore(aviso, phone.nextSibling);
      aviso.parentNode.insertBefore(marketing, aviso.nextSibling);
    }

    var priv = sec.querySelector('.leadpriv');
    if (priv) priv.remove();   /* el aviso ya va dentro del texto de consentimiento */

    /* La casilla de promociones solo se habilita con un teléfono válido: sin
       número no hay a dónde mandar nada, y aceptar algo inaplicable ensucia el
       registro de consentimientos. */
    var chk = marketing.querySelector('#waMarketing');
    function revisarTelefono() {
      var ok = !!normalizar(phone.value);
      chk.disabled = !ok;
      if (!ok) chk.checked = false;
      marketing.classList.toggle('pt-wa-off', !ok);
    }
    phone.addEventListener('input', revisarTelefono);
    revisarTelefono();

    /* Criterio 9 del brief: volver a este paso conserva el teléfono. El
       formulario no guarda nada entre pasos, así que quien retrocedía a
       revisar algo encontraba el campo vacío y tenía que escribirlo otra vez.
       Se usa sessionStorage y no localStorage a propósito: el número no tiene
       por qué sobrevivir a cerrar la pestaña. */
    try {
      var guardado = sessionStorage.getItem('pt_wa_telefono');
      if (guardado && !phone.value) { phone.value = guardado; revisarTelefono(); }
      var marcado = sessionStorage.getItem('pt_wa_marketing');
      if (marcado === '1' && !chk.disabled) chk.checked = true;
    } catch (e) {}

    phone.addEventListener('input', function () {
      try { sessionStorage.setItem('pt_wa_telefono', phone.value); } catch (e) {}
    });
    chk.addEventListener('change', function () {
      try { sessionStorage.setItem('pt_wa_marketing', chk.checked ? '1' : '0'); } catch (e) {}
    });

    /* ── Botones ─────────────────────────────────────────────────────────── */
    btnNext.textContent = 'Enviarme mi plan y ver el precio';

    var o = document.createElement('div');
    o.className = 'pt-wa-o';
    o.textContent = 'o';
    btnNext.parentNode.insertBefore(o, btnNext.nextSibling);

    /* Deja de ser un enlace pequeño: el brief pide un botón real, para que no
       parezca que el teléfono es obligatorio. */
    btnSkip.textContent = 'Saltar y ver mi precio';
    btnSkip.className = 'btn pt-wa-skip';

    var trust = sec.querySelector('.leadtrust');
    if (trust) trust.textContent = '🔒 Nunca compartimos tu número. Puedes salirte cuando quieras.';

    /* ── Registro ─────────────────────────────────────────────────────────
       En fase de captura para que corra antes que el listener que avanza de
       paso, y sin bloquear: si esto falla, la persona ve su precio igual. */
    /* Criterio 5: un teléfono incompleto solo detiene el botón de WhatsApp,
       nunca el de saltar, y el error aparece al intentarlo, no mientras se
       escribe. */
    var error = document.createElement('div');
    error.className = 'pt-wa-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;
    error.textContent = 'Ingresa un número de WhatsApp válido de 10 dígitos.';
    phone.parentNode.insertBefore(error, phone.nextSibling);

    phone.addEventListener('input', function () { error.hidden = true; });

    btnNext.addEventListener('click', function (ev) {
      var crudo = String(phone.value || '').replace(/\D/g, '');
      if (crudo && !normalizar(phone.value)) {
        /* Escribió algo pero no sirve: se detiene aquí y se le dice por qué.
           Con el campo vacío no se muestra error, porque el paso es opcional
           y el formulario lo deja pasar igual. */
        ev.preventDefault();
        ev.stopImmediatePropagation();
        error.hidden = false;
        phone.focus();
        return;
      }
      error.hidden = true;
    }, true);

    btnNext.addEventListener('click', function () {
      var tel = normalizar(phone.value);
      if (!tel) return;   /* vacío: avanza sin guardar nada */
      guardar({
        telefono: phone.value,
        telefono_normalizado: tel,
        plan_consent: true,
        marketing_consent: !!(chk && chk.checked),
        consent_version: VERSION_CONSENTIMIENTO,
      });
      evento('whatsapp_plan_requested', { marketing_consent: !!(chk && chk.checked) });
    }, true);

    btnSkip.addEventListener('click', function () {
      /* Sin teléfono no se guarda nada: el brief prohíbe crear un registro
         vacío, y un NULL en el consentimiento significa "no se le preguntó",
         que es distinto de "dijo que no". */
      evento('optional_whatsapp_step_skipped', {});
    }, true);

    evento('optional_whatsapp_step_viewed', {});
    return true;
  }

  function guardar(datos) {
    var t = window.PT_ORDER_TRACKING;
    if (!t || !t.session) return;
    try {
      fetch('https://wtgpqrcrakklrwfaucqb.supabase.co/functions/v1/save-quiz', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'upsert_session',
          session_id: t.session,
          telefono: datos.telefono,
          form_variant: 'ts002',
          attribution: t.atribucion ? t.atribucion() : undefined,
          whatsapp: {
            telefono_normalizado: datos.telefono_normalizado,
            plan_consent: datos.plan_consent,
            marketing_consent: datos.marketing_consent,
            consent_version: datos.consent_version,
          },
        }),
        keepalive: true,
      }).catch(function () {});
    } catch (e) {}
  }

  function evento(nombre, meta) {
    try { if (typeof window.PT_track === 'function') window.PT_track(nombre, meta); } catch (e) {}
  }

  /* El paso lo crea pt-plan-builder cuando el usuario avanza, así que puede no
     existir al cargar la página. */
  if (!montar()) {
    var intentos = 0;
    var t = setInterval(function () {
      if (montar() || ++intentos > 60) clearInterval(t);
    }, 250);
  }
})();
